import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const Applied = Loadable(lazy(() => import('./AppliedDash')));
const AppliedView = Loadable(lazy(() => import('./AppliedViewDash')));
const AppliedViewDashboard = Loadable(lazy(() => import('./AppliedViewDashboard')));

const appliedroutes = [
   { path: '/applied/dash-board', element: <Applied /> },
    { path: '/applied-dash-board/view', element: <AppliedView /> },
    { path: '/applied-dash-board/AppliedViewDashboard', element: <AppliedViewDashboard /> },


];

export default appliedroutes;